module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "footer"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "margin-bottom": "0.68rem"
    }
  }, [(_vm.$i18n.locale == 'ch') ? _c('img', {
    staticStyle: {
      "width": "2.07rem",
      "padding-top": "0.67rem"
    },
    attrs: {
      "src": require("../assets/images/footer_logo.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    staticStyle: {
      "width": "1.88rem",
      "padding-top": "0.67rem"
    },
    attrs: {
      "src": require("../assets/images/footer_logo2.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "0.58rem"
    }
  }, [_c('span', {
    staticClass: "footer_item"
  }, [_vm._v(_vm._s(_vm.$t("footer.text1")))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:86 755 8695 6559"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.text2")))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "0.57rem"
    }
  }, [_c('span', {
    staticClass: "footer_item"
  }, [_vm._v(_vm._s(_vm.$t("footer.text3")))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:86 755 8696 0615"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.text4")))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "0.53rem"
    }
  }, [_c('span', {
    staticClass: "footer_item"
  }, [_vm._v(_vm._s(_vm.$t("footer.text5")))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "Mailto:business@vrviu.com"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.text6")))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "0rem"
    }
  }, [_c('span', {
    staticClass: "footer_item",
    staticStyle: {
      "line-height": "1.5em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('footer.text7'))
    }
  })])]), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    staticClass: "sqcore_pic",
    attrs: {
      "src": require("../assets/images/sqcore.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "copyright center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('footer.text8'))
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e50a4a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 98
// module chunks = 0